import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  buttonName: PropTypes.string.isRequired,
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  trackButtonClick: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

const defaultProps = {
  component: 'span',
};

export function UnstyledSegmentClickTracker({
  buttonName,
  trackButtonClick,
  children,
  component,
  classes,
  ...other
}) {
  const Component = component;

  return (
    <Component
      className={classes.tracker}
      onKeyDown={() => trackButtonClick(buttonName)}
      onClick={() => trackButtonClick(buttonName)}
      {...other}
    >
      {children}
    </Component>
  );
}

UnstyledSegmentClickTracker.propTypes = propTypes;
UnstyledSegmentClickTracker.defaultProps = defaultProps;

const styles = () => ({
  tracker: {
    '&:focus': {
      outline: 'none',
    },
  },
});

export default withStyles(styles)(UnstyledSegmentClickTracker);
